import { Head } from "@inertiajs/react";
import { useEffect } from "react";
import type { SalonpageMagazineRedirectProps as Props } from "./_props";

export default function MagazineRedirect({ destinationUrl }: Props) {
  useEffect(() => {
    window.location.replace(destinationUrl);
  }, [destinationUrl]);

  return (
    <>
      <Head title="移動中です | Hairbook Salon">
        <meta name="robots" content="noindex" />
      </Head>
      <main className="grid min-h-screen place-items-center bg-white" aria-busy="true">
        <p className="sr-only">予約ページへ移動中です</p>
      </main>
    </>
  );
}
